export default __webpack_public_path__ + "static/media/onboardingAsideMb.1592a15c.png";